import {
  AvatarData,
  AvatarDataIcon,
  AvatarDataInitials,
  DecoratedAvatarData,
  StatusBadgeData,
  TypeBadgeData
} from "ui-ts";
import {CheckUtils, UserTeamVoData} from "od-ts";
import {NameUtils} from "@utils/name-utils";

export class UserTeamConverter {

  static convertToDecoratedAvatarData(userTeam: UserTeamVoData, fileUrl?: string, target?: DecoratedAvatarData): DecoratedAvatarData {
    if (CheckUtils.isEmpty(userTeam)) return null;

    var result = (target == null) ? new DecoratedAvatarData() : target;
    result.id = userTeam.id;
    result.displayName = userTeam.name;

    result.type = TypeBadgeData.TEAM;
    result.status = StatusBadgeData.INVISIBLE;
    result.avatarData = this.convertToAvatarData(userTeam, fileUrl);
    result.hideType = true;

    return result;
  }

  static convertToAvatarData(userTeam: UserTeamVoData, fileUrl?: string): AvatarData {
    if (CheckUtils.isEmpty(userTeam)) return null;

    return UserTeamConverter.getAvatarData(userTeam, "odi_userTeam");
  }

  static getAvatarData(userTeam: UserTeamVoData, iconName: string): AvatarDataInitials | AvatarDataIcon {
    if (!CheckUtils.isEmpty(userTeam.name)) {
      var initialsResult: AvatarDataInitials = new AvatarDataInitials();
      initialsResult.initials = NameUtils.getInitials(userTeam.name);
      initialsResult.color = "#999999";
      initialsResult.fontColor = "#FFFFFF";
      return initialsResult;
    } else {
      return UserTeamConverter.getAvatarDataIcon(iconName);
    }
  }

  static getAvatarDataIcon(iconName: string, iconColor = "#FFFFFF", borderColor = "#999999"): AvatarDataIcon {
    let iconResult: AvatarDataIcon = new AvatarDataIcon();
    iconResult.icon = iconName;
    iconResult.iconColor = iconColor;
    iconResult.borderColor = borderColor;
    return iconResult;
  }
}



// WEBPACK FOOTER //
// ./src/utils/converter/user-team-converter.ts